/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * ETag of last known submission version for optimistic concurrency control
 */
export type SubmissionCreateRequestLastKnownEtag = string | null;
